export const CCDAStructureDefinition2_1 = {
  ADMISSION_DIAGNOSIS_SECTION: ['2.16.840.1.113883.10.20.22.2.43'],
  ADMISSION_MEDICATION: ['2.16.840.1.113883.10.20.22.4.36'],
  ADMISSION_MEDICATIONS_SECTION: ['2.16.840.1.113883.10.20.22.2.44'],
  ADVANCE_DIRECTIVES_SECTION: [
    '2.16.840.1.113883.10.20.22.2.21',
    '2.16.840.1.113883.10.20.22.2.21.1',
  ],
  ADVANCE_DIRECTIVE_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.48'],
  ADVANCE_DIRECTIVE_ORGANIZER: ['2.16.840.1.113883.10.20.22.4.108'],
  AGE_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.31'],
  ALLERGIES_AND_INTOLERANCES_SECTION: [
    '2.16.840.1.113883.10.20.22.2.6',
    '2.16.840.1.113883.10.20.22.2.6.1',
  ],
  ALLERGY_CONCERN_ACT: ['2.16.840.1.113883.10.20.22.4.30'],
  ALLERGY_INTOLERANCE_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.7'],
  ALLERGY_STATUS_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.28'],
  ANESTHESIA_SECTION: ['2.16.840.1.113883.10.20.22.2.25'],
  ASSESSMENT_AND_PLAN_SECTION: ['2.16.840.1.113883.10.20.22.2.9'],
  ASSESSMENT_SCALE_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.69'],
  ASSESSMENT_SCALE_SUPPORTING_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.86'],
  ASSESSMENT_SECTION: ['2.16.840.1.113883.10.20.22.2.8'],
  AUTHORIZATION_ACTIVITY: ['2.16.840.1.113883.10.20.1.19'],
  AUTHOR_PARTICIPATION: ['2.16.840.1.113883.10.20.22.4.119'],
  BIRTH_SEX_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.200'],
  BOUNDARY_OBSERVATION: ['2.16.840.1.113883.10.20.6.2.11'],
  BRAND_NAME_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.301'],
  CAREGIVER_CHARACTERISTICS: ['2.16.840.1.113883.10.20.22.4.72'],
  CARE_PLAN: ['2.16.840.1.113883.10.20.22.1.15'],
  CARE_TEAMS_SECTION: ['2.16.840.1.113883.10.20.22.2.500'],
  CARE_TEAM_MEMBER_ACT: ['2.16.840.1.113883.10.20.22.4.500.1'],
  CARE_TEAM_MEMBER_SCHEDULE_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.500.3'],
  CARE_TEAM_ORGANIZER: ['2.16.840.1.113883.10.20.22.4.500'],
  CARE_TEAM_TYPE_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.500.2'],
  CATALOG_NUMBER_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.302'],
  CHARACTERISTICS_OF_HOME_ENVIRONMENT: ['2.16.840.1.113883.10.20.22.4.109'],
  CHIEF_COMPLAINT_AND_REASON_FOR_VISIT_SECTION: [
    '2.16.840.1.113883.10.20.22.2.13',
  ],
  CHIEF_COMPLAINT_SECTION: ['1.3.6.1.4.1.19376.1.5.3.1.1.13.2.1'],
  CODE_OBSERVATIONS: ['2.16.840.1.113883.10.20.6.2.13'],
  COGNITIVE_STATUS_PROBLEM_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.73'],
  COMMENT_ACTIVITY: ['2.16.840.1.113883.10.20.22.4.64'],
  COMPANY_NAME_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.303'],
  COMPLICATIONS_SECTION: ['2.16.840.1.113883.10.20.22.2.37'],
  CONSULTATION_NOTE: ['2.16.840.1.113883.10.20.22.1.4'],
  CONTINUITY_OF_CARE_DOCUMENT: ['2.16.840.1.113883.10.20.22.1.2'],
  COURSE_OF_CARE_SECTION: ['2.16.840.1.113883.10.20.22.2.64'],
  COVERAGE_ACTIVITY: ['2.16.840.1.113883.10.20.22.4.60'],
  CRITICALITY_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.145'],
  CULTURAL_AND_RELIGIOUS_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.111'],
  DATE_OF_DIAGNOSIS_ACT: ['2.16.840.1.113883.10.20.22.4.502'],
  DECEASED_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.79'],
  DEVICE_IDENTIFIER_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.304'],
  DIAGNOSTIC_IMAGING_REPORT: ['2.16.840.1.113883.10.20.22.1.5'],
  DICOM_OBJECT_CATALOG_SECTION_DCM_121181: ['2.16.840.1.113883.10.20.6.1.1'],
  DISCHARGE_DIAGNOSIS_SECTION: ['2.16.840.1.113883.10.20.22.2.24'],
  DISCHARGE_DIET_SECTION: ['1.3.6.1.4.1.19376.1.5.3.1.3.33'],
  DISCHARGE_MEDICATION: ['2.16.840.1.113883.10.20.22.4.35'],
  DISCHARGE_MEDICATIONS_SECTION: [
    '2.16.840.1.113883.10.20.22.2.11',
    '2.16.840.1.113883.10.20.22.2.11.1',
  ],
  DISCHARGE_SUMMARY: ['2.16.840.1.113883.10.20.22.1.8'],
  DISTINCT_IDENTIFICATION_CODE_OBSERVATION: [
    '2.16.840.1.113883.10.20.22.4.308',
  ],
  DRUG_MONITORING_ACT: ['2.16.840.1.113883.10.20.22.4.123'],
  DRUG_VEHICLE: ['2.16.840.1.113883.10.20.22.4.24'],
  ENCOUNTERS_SECTION: [
    '2.16.840.1.113883.10.20.22.2.22',
    '2.16.840.1.113883.10.20.22.2.22.1',
    '2.16.840.1.113883.10.20.22.4.49',
    '2.16.840.1.113883.10.20.22.4.32',
    '2.16.840.1.113883.10.20.22.4.80',
    '2.16.840.1.113883.10.20.22.4.4',
    '2.16.840.1.113883.10.20.22.4.6',
  ],
  ENCOUNTER_ACTIVITY: ['2.16.840.1.113883.10.20.22.4.49'],
  ENCOUNTER_DIAGNOSIS: ['2.16.840.1.113883.10.20.22.4.80'],
  ENTRY_REFERENCE: ['2.16.840.1.113883.10.20.22.4.122'],
  ESTIMATED_DATE_OF_DELIVERY: ['2.16.840.1.113883.10.20.15.3.1'],
  EXPIRATION_DATE_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.309'],
  EXTERNAL_DOCUMENT_REFERENCE: ['2.16.840.1.113883.10.20.22.4.115'],
  FAMILY_HISTORY_DEATH_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.47'],
  FAMILY_HISTORY_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.46'],
  FAMILY_HISTORY_ORGANIZER: ['2.16.840.1.113883.10.20.22.4.45'],
  FAMILY_HISTORY_SECTION: ['2.16.840.1.113883.10.20.22.2.15'],
  FETUS_SUBJECT_CONTEXT: ['2.16.840.1.113883.10.20.6.2.3'],
  FINDINGS_SECTION: ['2.16.840.1.113883.10.20.6.1.2'],
  FUNCTIONAL_STATUS_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.67'],
  FUNCTIONAL_STATUS_ORGANIZER: ['2.16.840.1.113883.10.20.22.4.66'],
  FUNCTIONAL_STATUS_PROBLEM_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.68'],
  FUNCTIONAL_STATUS_SECTION: ['2.16.840.1.113883.10.20.22.2.14'],
  GENDER_IDENTITY_OBSERVATION: ['2.16.840.1.113883.10.20.34.3.45'],
  GENERAL_STATUS_SECTION: ['2.16.840.1.113883.10.20.2.5'],
  GOALS_SECTION: ['2.16.840.1.113883.10.20.22.2.60'],
  GOAL_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.121'],
  HANDOFF_COMMUNICATION_PARTICIPANTS: ['2.16.840.1.113883.10.20.22.4.141'],
  HEALTH_CONCERNS_SECTION: ['2.16.840.1.113883.10.20.22.2.58'],
  HEALTH_CONCERN_ACT: ['2.16.840.1.113883.10.20.22.4.132'],
  HEALTH_STATUS_EVALUATIONS_AND_OUTCOMES_SECTION: [
    '2.16.840.1.113883.10.20.22.2.61',
  ],
  HEALTH_STATUS_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.5'],
  HIGHEST_PRESSURE_ULCER_STAGE: ['2.16.840.1.113883.10.20.22.4.77'],
  HISTORY_AND_PHYSICAL: ['2.16.840.1.113883.10.20.22.1.3'],
  HISTORY_OF_PRESENT_ILLNESS_SECTION: ['1.3.6.1.4.1.19376.1.5.3.1.3.4'],
  HOSPITAL_ADMISSION_DIAGNOSIS: ['2.16.840.1.113883.10.20.22.4.34'],
  HOSPITAL_CONSULTATIONS_SECTION: ['2.16.840.1.113883.10.20.22.2.42'],
  HOSPITAL_COURSE_SECTION: ['1.3.6.1.4.1.19376.1.5.3.1.3.5'],
  HOSPITAL_DISCHARGE_DIAGNOSIS: ['2.16.840.1.113883.10.20.22.4.33'],
  HOSPITAL_DISCHARGE_INSTRUCTIONS_SECTION: ['2.16.840.1.113883.10.20.22.2.41'],
  HOSPITAL_DISCHARGE_PHYSICAL_SECTION: ['1.3.6.1.4.1.19376.1.5.3.1.3.26'],
  HOSPITAL_DISCHARGE_STUDIES_SUMMARY_SECTION: [
    '2.16.840.1.113883.10.20.22.2.16',
  ],
  IMMUNIZATIONS_SECTION: [
    '2.16.840.1.113883.10.20.22.2.2',
    '2.16.840.1.113883.10.20.22.2.2.1',
  ],
  IMMUNIZATION_ACTIVITY: ['2.16.840.1.113883.10.20.22.4.52'],
  IMMUNIZATION_MEDICATION_INFORMATION: ['2.16.840.1.113883.10.20.22.4.54'],
  IMMUNIZATION_REFUSAL_REASON: ['2.16.840.1.113883.10.20.22.4.53'],
  IMPLANTABLE_DEVICE_STATUS_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.305'],
  IMPLANTS_SECTION: ['2.16.840.1.113883.10.20.22.2.33'],
  INDICATION: ['2.16.840.1.113883.10.20.22.4.19'],
  INSTRUCTION: ['2.16.840.1.113883.10.20.22.4.20'],
  INSTRUCTIONS_SECTION: ['2.16.840.1.113883.10.20.22.2.45'],
  INTERVENTIONS_SECTION: ['2.16.840.1.113883.10.20.21.2.3'],
  INTERVENTION_ACT: ['2.16.840.1.113883.10.20.22.4.131'],
  LATEX_SAFETY_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.314'],
  LONGITUDINAL_CARE_WOUND_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.114'],
  LOT_OR_BATCH_NUMBER_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.315'],
  MANUFACTURING_DATE_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.316'],
  MEDICAL_EQUIPMENT_ORGANIZER: ['2.16.840.1.113883.10.20.22.4.135'],
  MEDICAL_EQUIPMENT_SECTION: ['2.16.840.1.113883.10.20.22.2.23'],
  MEDICAL_HISTORY_SECTION: ['2.16.840.1.113883.10.20.22.2.39'],
  MEDICATIONS_ADMINISTERED_SECTION: ['2.16.840.1.113883.10.20.22.2.38'],
  MEDICATIONS_SECTION: [
    '2.16.840.1.113883.10.20.22.2.1',
    '2.16.840.1.113883.10.20.22.2.1.1',
  ],
  MEDICATION_ACTIVITY: ['2.16.840.1.113883.10.20.22.4.16'],
  MEDICATION_DISPENSE: ['2.16.840.1.113883.10.20.22.4.18'],
  MEDICATION_FREE_TEXT_SIG: ['2.16.840.1.113883.10.20.22.4.147'],
  MEDICATION_INFORMATION: ['2.16.840.1.113883.10.20.22.4.23'],
  MEDICATION_SUPPLY_ORDER: ['2.16.840.1.113883.10.20.22.4.17'],
  MENTAL_STATUS_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.74'],
  MENTAL_STATUS_ORGANIZER: ['2.16.840.1.113883.10.20.22.4.75'],
  MENTAL_STATUS_SECTION: ['2.16.840.1.113883.10.20.22.2.56'],
  MODEL_NUMBER_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.317'],
  MRI_SAFETY_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.318'],
  NON_MEDICINAL_SUPPLY_ACTIVITY: ['2.16.840.1.113883.10.20.22.4.50'],
  NOTES_SECTION: ['2.16.840.1.113883.10.20.22.2.65'],
  NOTE_ACTIVITY: ['2.16.840.1.113883.10.20.22.4.202'],
  NUMBER_OF_PRESSURE_ULCERS_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.76'],
  NUTRITIONAL_STATUS_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.124'],
  NUTRITION_ASSESSMENT: ['2.16.840.1.113883.10.20.22.4.138'],
  NUTRITION_RECOMMENDATION: ['2.16.840.1.113883.10.20.22.4.130'],
  NUTRITION_SECTION: ['2.16.840.1.113883.10.20.22.2.57'],
  OBJECTIVE_SECTION: ['2.16.840.1.113883.10.20.21.2.1'],
  OBSERVER_CONTEXT: ['2.16.840.1.113883.10.20.6.2.4'],
  OPERATIVE_NOTE: ['2.16.840.1.113883.10.20.22.1.7'],
  OPERATIVE_NOTE_FLUIDS_SECTION: ['2.16.840.1.113883.10.20.7.12'],
  OPERATIVE_NOTE_SURGICAL_PROCEDURE_SECTION: ['2.16.840.1.113883.10.20.7.14'],
  OUTCOME_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.144'],
  PAST_MEDICAL_HISTORY: ['2.16.840.1.113883.10.20.22.2.20'],
  PATIENT_REFERRAL_ACT: ['2.16.840.1.113883.10.20.22.4.140'],
  PAYERS_SECTION: ['2.16.840.1.113883.10.20.22.2.18'],
  PHYSICAL_EXAM_SECTION: ['2.16.840.1.113883.10.20.2.10'],
  PHYSICIAN_OF_RECORD_PARTICIPANT: ['2.16.840.1.113883.10.20.6.2.2'],
  PHYSICIAN_READING_STUDY_PERFORMER: ['2.16.840.1.113883.10.20.6.2.1'],
  PLANNED_ACT: ['2.16.840.1.113883.10.20.22.4.39'],
  PLANNED_COVERAGE: ['2.16.840.1.113883.10.20.22.4.129'],
  PLANNED_ENCOUNTER: ['2.16.840.1.113883.10.20.22.4.40'],
  PLANNED_IMMUNIZATION_ACTIVITY: ['2.16.840.1.113883.10.20.22.4.120'],
  PLANNED_INTERVENTION_ACT: ['2.16.840.1.113883.10.20.22.4.146'],
  PLANNED_MEDICATION_ACTIVITY: ['2.16.840.1.113883.10.20.22.4.42'],
  PLANNED_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.44'],
  PLANNED_PROCEDURE: ['2.16.840.1.113883.10.20.22.4.41'],
  PLANNED_PROCEDURE_SECTION: ['2.16.840.1.113883.10.20.22.2.30'],
  PLANNED_SUPPLY: ['2.16.840.1.113883.10.20.22.4.43'],
  PLAN_OF_TREATMENT_SECTION: ['2.16.840.1.113883.10.20.22.2.10'],
  POLICY_ACTIVITY: ['2.16.840.1.113883.10.20.22.4.61'],
  POSTOPERATIVE_DIAGNOSIS_SECTION: ['2.16.840.1.113883.10.20.22.2.35'],
  POSTPROCEDURE_DIAGNOSIS: ['2.16.840.1.113883.10.20.22.4.51'],
  POSTPROCEDURE_DIAGNOSIS_SECTION: ['2.16.840.1.113883.10.20.22.2.36'],
  PRECONDITION_FOR_SUBSTANCE_ADMINISTRATION: [
    '2.16.840.1.113883.10.20.22.4.25',
  ],
  PREGNANCY_OBSERVATION: ['2.16.840.1.113883.10.20.15.3.8'],
  PREOPERATIVE_DIAGNOSIS: ['2.16.840.1.113883.10.20.22.4.65'],
  PREOPERATIVE_DIAGNOSIS_SECTION: ['2.16.840.1.113883.10.20.22.2.34'],
  PRESSURE_ULCER_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.70'],
  PRIORITY_PREFERENCE: ['2.16.840.1.113883.10.20.22.4.143'],
  PROBLEM_CONCERN_ACT: ['2.16.840.1.113883.10.20.22.4.3'],
  PROBLEM_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.4'],
  PROBLEM_SECTION: [
    '2.16.840.1.113883.10.20.22.2.5',
    '2.16.840.1.113883.10.20.22.2.5.1',
  ],
  PROBLEM_STATUS: ['2.16.840.1.113883.10.20.22.4.6'],
  PROCEDURES_SECTION: [
    '2.16.840.1.113883.10.20.22.2.7',
    '2.16.840.1.113883.10.20.22.2.7.1',
  ],
  PROCEDURE_ACTIVITY_ACT: ['2.16.840.1.113883.10.20.22.4.12'],
  PROCEDURE_ACTIVITY_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.13'],
  PROCEDURE_ACTIVITY_PROCEDURE: ['2.16.840.1.113883.10.20.22.4.14'],
  PROCEDURE_CONTEXT: ['2.16.840.1.113883.10.20.6.2.5'],
  PROCEDURE_DESCRIPTION_SECTION: ['2.16.840.1.113883.10.20.22.2.27'],
  PROCEDURE_DISPOSITION_SECTION: ['2.16.840.1.113883.10.20.18.2.12'],
  PROCEDURE_ESTIMATED_BLOOD_LOSS_SECTION: ['2.16.840.1.113883.10.20.18.2.9'],
  PROCEDURE_FINDINGS_SECTION: ['2.16.840.1.113883.10.20.22.2.28'],
  PROCEDURE_IMPLANTS_SECTION: ['2.16.840.1.113883.10.20.22.2.40'],
  PROCEDURE_INDICATIONS_SECTION: ['2.16.840.1.113883.10.20.22.2.29'],
  PROCEDURE_NOTE: ['2.16.840.1.113883.10.20.22.1.6'],
  PROCEDURE_SPECIMENS_TAKEN_SECTION: ['2.16.840.1.113883.10.20.22.2.31'],
  PRODUCT_INSTANCE: ['2.16.840.1.113883.10.20.22.4.37'],
  PROGNOSIS_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.113'],
  PROGRESS_NOTE: ['2.16.840.1.113883.10.20.22.1.9'],
  PROGRESS_TOWARD_GOAL_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.110'],
  PROVENANCE_ASSEMBLER_PARTICIPATION: ['2.16.840.1.113883.10.20.22.5.7'],
  PROVENANCE_AUTHOR_PARTICIPATION: ['2.16.840.1.113883.10.20.22.5.6'],
  PURPOSE_OF_REFERENCE_OBSERVATION: ['2.16.840.1.113883.10.20.6.2.9'],
  QUANTITY_MEASUREMENT_OBSERVATION: ['2.16.840.1.113883.10.20.6.2.14'],
  REACTION_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.9'],
  REASON_FOR_REFERRAL_SECTION: ['1.3.6.1.4.1.19376.1.5.3.1.3.1'],
  REASON_FOR_VISIT_SECTION: ['2.16.840.1.113883.10.20.22.2.12'],
  REFERENCED_FRAMES_OBSERVATION: ['2.16.840.1.113883.10.20.6.2.10'],
  REFERRAL_NOTE: ['2.16.840.1.113883.10.20.22.1.14'],
  RESULTS_SECTION: [
    '2.16.840.1.113883.10.20.22.2.3',
    '2.16.840.1.113883.10.20.22.2.3.1',
  ],
  RESULT_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.2'],
  RESULT_ORGANIZER: ['2.16.840.1.113883.10.20.22.4.1'],
  REVIEW_OF_SYSTEMS_SECTION: ['1.3.6.1.4.1.19376.1.5.3.1.3.18'],
  RISK_CONCERN_ACT: ['2.16.840.1.113883.10.20.22.4.136'],
  SECTION_TIME_RANGE_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.201'],
  SELF_CARE_ACTIVITIES: ['2.16.840.1.113883.10.20.22.4.128'],
  SENSORY_STATUS: ['2.16.840.1.113883.10.20.22.4.127'],
  SERIAL_NUMBER_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.319'],
  SERIES_ACT: ['2.16.840.1.113883.10.20.22.4.63'],
  SERVICE_DELIVERY_LOCATION: ['2.16.840.1.113883.10.20.22.4.32'],
  SEVERITY_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.8'],
  SEXUAL_ORIENTATION_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.501'],
  SMOKING_STATUS_MEANINGFUL_USE: ['2.16.840.1.113883.10.20.22.4.78'],
  SOCIAL_HISTORY_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.38'],
  SOCIAL_HISTORY_SECTION: ['2.16.840.1.113883.10.20.22.2.17'],
  SOP_INSTANCE_OBSERVATION: ['2.16.840.1.113883.10.20.6.2.8'],
  STUDY_ACT: ['2.16.840.1.113883.10.20.6.2.6'],
  SUBJECTIVE_SECTION: ['2.16.840.1.113883.10.20.21.2.2'],
  SUBSTANCE_ADMINISTERED_ACT: ['2.16.840.1.113883.10.20.22.4.118'],
  SUBSTANCE_OR_DEVICE_ALLERGY_INTOLERANCE_OBSERVATION: [
    '2.16.840.1.113883.10.20.24.3.90',
  ],
  SURGERY_DESCRIPTION_SECTION: ['2.16.840.1.113883.10.20.22.2.26'],
  SURGICAL_DRAINS_SECTION: ['2.16.840.1.113883.10.20.7.13'],
  TEXT_OBSERVATION: ['2.16.840.1.113883.10.20.6.2.12'],
  TOBACCO_USE: ['2.16.840.1.113883.10.20.22.4.85'],
  TRANSFER_SUMMARY: ['2.16.840.1.113883.10.20.22.1.13'],
  UDI_ORGANIZER: ['2.16.840.1.113883.10.20.22.4.311'],
  UNSTRUCTURED_DOCUMENT: ['2.16.840.1.113883.10.20.22.1.10'],
  US_REALM_ADDRESS: ['2.16.840.1.113883.10.20.22.5.2'],
  US_REALM_DATE_AND_TIME: [
    '2.16.840.1.113883.10.20.22.5.3',
    '2.16.840.1.113883.10.20.22.5.4',
  ],
  US_REALM_HEADER: ['2.16.840.1.113883.10.20.22.1.1'],
  US_REALM_HEADER_FOR_PATIENT_GENERATED_DOCUMENT: [
    '2.16.840.1.113883.10.20.29.1',
  ],
  US_REALM_PATIENT_NAME: ['2.16.840.1.113883.10.20.22.5.1'],
  US_REALM_PERSON_NAME: ['2.16.840.1.113883.10.20.22.5.1.1'],
  VITAL_SIGNS_ORGANIZER: ['2.16.840.1.113883.10.20.22.4.26'],
  VITAL_SIGNS_SECTION: [
    '2.16.840.1.113883.10.20.22.2.4',
    '2.16.840.1.113883.10.20.22.2.4.1',
  ],
  VITAL_SIGN_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.27'],
  WOUND_CHARACTERISTIC: ['2.16.840.1.113883.10.20.22.4.134'],
  WOUND_MEASUREMENT_OBSERVATION: ['2.16.840.1.113883.10.20.22.4.133'],
};

export type CCDAStructureDefinitionKeys2_1 =
  keyof typeof CCDAStructureDefinition2_1;
